import Collapse from '@eversports/react-components/primitives/Collapse'
import Text, { SimpleText } from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React, { useState } from 'react'

import { Localized } from '../../localization/react'
import Activity from '../../typings/Activity'

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer',
  },
})

interface Props {
  activities: Array<Activity>
}

const ValidActivities: React.FC<React.PropsWithChildren<Props>> = ({ activities }) => {
  const classes = useStyles()
  const [isCollapsed, setIsCollapsed] = useState(true)

  const firstThreeActivities = activities.slice(0, 3)
  const remainingActivities = activities.slice(3, activities.length)

  const handleClick = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <div>
      <Text size="small" color="subtleText">
        <Localized id="valid-activities" />
      </Text>
      {activities.length === 0 && (
        <Text>
          <Localized id="empty-activities" />
        </Text>
      )}
      {firstThreeActivities.map((activity) => (
        <Text key={activity.id}>{activity.name}</Text>
      ))}
      {remainingActivities.length > 0 && (
        <>
          <Collapse in={!isCollapsed}>
            {remainingActivities.map((activity) => (
              <SimpleText size="large" key={activity.id}>
                {activity.name}
              </SimpleText>
            ))}
          </Collapse>
          <Text color="secondary.main" className={classes.pointer} onClick={handleClick}>
            {isCollapsed ? <Localized id="show-more" /> : <Localized id="show-less" />}
          </Text>
        </>
      )}
    </div>
  )
}

export default ValidActivities
